import { motion, useReducedMotion } from "framer-motion";

// Slower, more graceful easing for an immersive, emotional feel
const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 52, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for hero headings — slower, cinematic cadence
export function LineReveal({ lines, className = "", delayBase = 0.2 }) {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.05em]">
          <motion.span
            className="block"
            initial={reduce ? { opacity: 0 } : { y: "112%" }}
            animate={reduce ? { opacity: 1 } : { y: 0 }}
            transition={{ duration: 1.25, delay: delayBase + i * 0.16, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Gentle image reveal with a subtle scale settle
export function ImageReveal({ children, className = "", delay = 0 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, scale: 1.06 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.5, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
